var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: _vm.title, size: "xl", "hide-footer": "" },
    },
    [
      _c("b-table", {
        staticClass: "mb-0",
        attrs: {
          fields: _vm.fields,
          items: _vm.items,
          "tbody-tr-class": _vm.rowClass,
          "sticky-header": "calc(100vh - 160px)",
          "label-sort-asc": "",
          "label-sort-desc": "",
          "label-sort-clear": "",
          "no-border-collapse": "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(is_conform)",
            fn: function (cell) {
              return [
                _c("i", {
                  staticClass: "fa-solid",
                  class: cell.value ? "fa-circle-check" : "fa-circle-xmark",
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }